import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import ScenarioSelectionRedefinedWrapperTemplate
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate/Content';

const metaOverrideSet = buildFacetDesignOverride();

const ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate = ({
  resource,
}) => {
  return (
    <ScenarioSelectionRedefinedWrapperTemplate
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewContent}
    />
  );
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate.defaultProps = {
};

ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default ScenarioSelectionRedefinedTheYearAheadGoalStrategiesOverviewStepTemplate;
